import client from './client';
import { SpeedingEvent, PaginatedResponse } from '../types';

export interface EventListParams {
  page?: number;
  limit?: number;
  apartment_id?: string;
  start_date?: string;
  end_date?: string;
  apartment_name?: string;
  car_number?: string;
  sort?: string;
}

export const getList = async (params: EventListParams = {}): Promise<PaginatedResponse<SpeedingEvent>> => {
  const res = await client.get('/api/v1/events/speeding', { params });
  return res.data;
};

export const getById = async (id: string): Promise<SpeedingEvent> => {
  const res = await client.get(`/api/v1/events/speeding/${id}`);
  return res.data;
};
